<template>
  <div>
    <div class="row" v-if="withDisplayName">
      <div class="col-md-6">
        <div class="form-group m-b-10">
          <label class="control-label">連絡先名</label>
          <input type="text" class="form-control" maxlength="30"
                 v-model="address.display_name"
                 @change="onChange">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group m-b-10">
          <label class="control-label">郵便番号</label>
          <input type="text" class="form-control"
                 maxlength="100"
                 v-model="address.postal_code"
                 @change="onChange">
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group m-b-10">
          <label class="control-label">都道府県</label>
          <select-code :code-group="Code.PREFECTURE"
                       v-model="address.prefecture_cd"
                       @change="onChange"/>
        </div>
      </div>
    </div>
    <!-- row -->
    <div class="row">
      <div class="col-md-6">
        <div class="form-group m-b-10">
          <label class="control-label">市区町村</label>
          <input type="text" class="form-control"
                 maxlength="100"
                 v-model="address.addr1"
                 @change="onChange">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="control-label">町名・番地・建物名</label>
        <div class="form-group m-b-10">
          <input type="text" class="form-control"
                 maxlength="100"
                 v-model="address.addr2"
                 @change="onChange">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label class="control-label">電話番号</label>
        <div class="form-group">
          <input class="form-control"
                 name="address.tel1"
                 type="text"
                 maxlength="15"
                 v-model="address.tel1"
                 @change="onChange">
        </div>
      </div>
      <div class="col-md-3">
        <label class="control-label">携帯電話</label>
        <div class="form-group">
          <input type="text" class="form-control"
                 maxlength="15"
                 v-model="address.tel2"
                 @change="onChange">
        </div>
      </div>
      <div class="col-md-3">
        <label class="control-label">FAX</label>
        <div class="form-group">
          <input type="text" class="form-control"
                 maxlength="15"
                 v-model="address.fax"
                 @change="onChange">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <label class="control-label">Eメール</label>
        <div class="form-group">
          <input class="form-control"
                 name="address.email"
                 type="text"
                 maxlength="100"
                 v-model="address.email"
                 @change="onChange">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import SelectCode from './SelectCode'
import Constants from '../constants'

// Constants
const Code = computed(() => Constants.Code || {})

// Props
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  displayName: {
    type: String,
    required: true
  },
  withDisplayName: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['update:modelValue', 'change'])

// Data
const address = ref({})

// Methods
const onChange = (event) => {
  emit('update:modelValue', address.value)
  emit('change', event)
}

// Watchers
watch(() => props.modelValue, (newVal) => {
  address.value = newVal
}, { deep: true })

// Lifecycle hooks
onMounted(() => {
  address.value = props.modelValue
})
</script>

<style scoped>

</style>
